import React from 'react';
import { Typography } from "@mui/material";

import makeStyles from '@mui/styles/makeStyles';

const useStyles = makeStyles(theme =>({
    baftaViewLogoRoot: {
        textAlign: 'center',
    },
    baftaViewLogoBafta: {
        paddingTop: theme.spacing(0.5),
    },
    baftaViewLogoView: {
        paddingBottom: theme.spacing(0.5),
    },
}));
export default function BaftaViewTextLogo() {
    const classes = useStyles();
    return (
        <Typography variant="h4" component="h1" className={["upper", classes.baftaViewLogoRoot].join(" ")}>
            <div className={classes.baftaViewLogoBafta}>Bafta</div>
            <div className={classes.baftaViewLogoView}>View</div>
        </Typography>
    );
}